//import liraries
import React from 'react';
import { View, TouchableOpacity, Dimensions,Text } from 'react-native';
import { FONTS } from '../../../constant';
import CText from '../../../common/CText';
import { CreateResponsiveStyle, DEVICE_SIZES } from 'rn-responsive-styles';
const { width } = Dimensions.get("window");


/* status=done||pending||rejected */

const TiDisputeStatusCard = (props) => {
const styles = useStyles();
    return (
        <TouchableOpacity style={[styles.cardStyle,{borderColor: props.statusTitle == "Dispute In Progress" ? "#ff9006" : props.statusTitle == "Closed" ? "#43b32e" : "red" }]} onPress={props.onPress}>
            <View style={styles.cardContainer}>
                {props?.header && 
                <View style={styles.cardItem}>
                    <CText.headerDesc style={{fontFamily:FONTS.Inter}}>{props?.header}</CText.headerDesc>
                </View>}
                <View style={styles.cardItem}>
                    <CText.headerDesc style={{fontFamily:FONTS.Inter}}>Dispute ID</CText.headerDesc>
                    <View style={styles.cardItemValue}>
                        <CText.headerDesc>: </CText.headerDesc>
                        <CText.headerDesc style={{fontFamily:FONTS.InterMedium,color:"#333f54"}}>&nbsp;{props.disputeId}</CText.headerDesc>
                    </View>
                </View>
                <View style={styles.cardItem}>
                <CText.headerDesc style={{fontFamily:FONTS.Inter}}>Status</CText.headerDesc>
                    <View style={styles.cardItemValue}>
                    <CText.headerDesc style={{}}>: </CText.headerDesc>
                    <CText.headerDesc style={{fontFamily:FONTS.InterBold,color:"#333f54",opacity:1}}> {props.statusTitle}</CText.headerDesc>
                    </View>
                </View>
            </View>
           
        </TouchableOpacity>
    );
};

const useStyles = CreateResponsiveStyle({
    cardStyle: {
        width: 311,
        height: 80,
        backgroundColor: "#ffffff",
        shadowColor:"#29000000",
        elevation:4,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#ccd0d5",
        borderRadius: 12,
        marginVertical: 10,
        paddingHorizontal: 13,
        paddingVertical: 20,
        flexDirection: "row",
        justifyContent: "space-between"
    },
    cardContainer: {
        width: width - 160,
        marginLeft: 13,
         justifyContent:"center",
    },
    cardItem: {
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        paddingVertical:3
    },
    cardItemValue: {
        flexDirection: "row",
        width: width - 250,
        
        
    }
},
{
        [DEVICE_SIZES.LG]: {
        

        },
        [DEVICE_SIZES.MD]: {
            
        },
        [DEVICE_SIZES.SM]: {
            
        },
        [DEVICE_SIZES.XS]: {
            cardStyle: {
                width: "100%",
                height: 80,
                backgroundColor: "#ffffff",
                shadowColor:"#29000000",
                elevation:4,
                borderStyle: "solid",
                borderWidth: 1,
                borderColor: "#ccd0d5",
                borderRadius: 12,
                marginVertical: 10,
                paddingHorizontal: 13,
                paddingVertical: 20,
                flexDirection: "row",
                justifyContent: "space-between"
            },
            cardContainer: {
                width: width - 160,
                marginLeft: 13,
                 justifyContent:"center",
            },
            cardItem: {
                flexDirection: "row",
                justifyContent: "space-between",
                width: "100%",
                paddingVertical:3
            },
            cardItemValue: {
                flexDirection: "row",
                width: width - 220,
                
                
            }
        }
    });

export default TiDisputeStatusCard;
